import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta } from '../data/content';
export function FinalCta() {
  return <section className="bg-night" data-id="element-78" data-mp="vgqwwj1g32gg">
      <div className="mx-auto max-w-3xl px-5 pt-16 text-center sm:px-6 lg:pt-24" data-id="element-79" data-mp="vhiqxpfe8s4m">
        <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-parchment sm:text-[2.6rem]" data-id="element-80" data-mp="19cumu05acon4">
          Cuando necesites una Palabra de Dios, sabrás exactamente dónde buscar.
        </h2>
        <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-parchment/75 sm:text-lg" data-id="element-81" data-mp="1ee1vs2j5ztvd">
          Ten cerca una palabra de paz, fortaleza, confianza y esperanza para esos momentos
          en los que más la necesitas.
        </p>

        <div className="mx-auto mt-9 max-w-md" data-id="element-82" data-mp="1o4ddqszoo3l9">
          <CtaButton size="block" href={checkoutUrl} data-id="element-83" data-mp="223d0tw7jsafb">
            {cta.label}
          </CtaButton>
          <p className="mt-3 font-sans text-xs text-parchment/55 sm:text-sm" data-id="element-84" data-mp="1x4tf9wwv90nh">
            {cta.finalMicro}
          </p>
        </div>
      </div>
    </section>;
}